import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["id", "dateTime", "systemTime", "readoutFunctions", "locale"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useInterval from 'hooks/useInterval';
import { date, getDateString } from './getDateString';
import { jsx as _jsx } from "react/jsx-runtime";
function useForceUpdate() {
  var _useReducer = useReducer(function (e) {
      return e + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  return forceUpdate;
}
function Time(_ref) {
  var _i18n$language;
  var id = _ref.id,
    dateTime = _ref.dateTime,
    systemTime = _ref.systemTime,
    readoutFunctionsProp = _ref.readoutFunctions,
    localeProp = _ref.locale,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // Force update
  var forceUpdate = useForceUpdate();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useState = useState(function () {
      var systemDateTime = date(systemTime);
      return systemDateTime ? systemDateTime.getTime() - Date.now() : 0;
    }),
    _useState2 = _slicedToArray(_useState, 1),
    systemOffset = _useState2[0];
  var defaultReadoutFunctions = {
    secondsAgoReadout: function secondsAgoReadout() {
      return t('time_ago_just_now');
    },
    minutesAgoReadout: function minutesAgoReadout(count) {
      return t('time_ago_minute', {
        count: count
      });
    }
  };
  var readoutFunctions = readoutFunctionsProp ? _objectSpread(_objectSpread({}, defaultReadoutFunctions), readoutFunctionsProp) : defaultReadoutFunctions;
  var locale = localeProp || ((_i18n$language = i18n.language) === null || _i18n$language === void 0 ? void 0 : _i18n$language.slice(0, 5));

  // Get the date string and the delay before running the next loop
  var _getDateString = getDateString({
      readoutFunctions: readoutFunctions,
      dateTime: dateTime,
      locale: locale,
      systemOffset: systemOffset
    }),
    dateString = _getDateString.dateString,
    delay = _getDateString.delay;

  // Set the datestring
  useInterval(forceUpdate, delay);
  var fmtDate = date(dateTime);
  return /*#__PURE__*/_jsx("time", _objectSpread(_objectSpread({
    id: id,
    dateTime: fmtDate === null || fmtDate === void 0 ? void 0 : fmtDate.toISOString(),
    title: fmtDate ? fmtDate.toLocaleString() : undefined
  }, otherProps), {}, {
    children: dateString
  }));
}
export default Time;